module.exports = __webpack_public_path__ + "static/media/mrmeeseeksIcon.01ced93d.png";